import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import {
  saveAuthToCookie,
  saveUserToCookie,
  getTokenFromCookie,
  getUserFromCookie,
  deleteCookie,
} from '@/utils/auth/cookies';

import spinnerStore from './modules/common/spinnerStore';
import elaStore from './modules/ela/elaStore';
import codeStore from './modules/code/codeStore';
import dialogStore from './modules/dialog/dialogStore';
import menuStore from './modules/common/menuStore';
import workLog from './modules/workLog/workLogStore';

export default new Vuex.Store({
  state: {
    // 쿠키와 연결됨
    userData: getUserFromCookie() || null,
    authToken: getTokenFromCookie('authToken') || '',
    userKey: getTokenFromCookie('userKey') || '',
    sessionToken: getTokenFromCookie('sessionToken') || '',
    // 헤더에 담을 토큰
    tokenObj: {},
    initializedUserData: {
      ssnEnterCd: '',
      ssnSabun: '',
      ssnName: '',
      ssnOrgCd: '',
      id: '',
      profileImgPath: '',
      orgChiefYn: '',
      authGroup: '',
      lbsUseYn: '',
    },

    TAGAG_BTN_FLAG: true,
    LBS_FLAG: false,
    LBS_TEST_DATA: '출퇴근 불가 지역!',

    BOTTOM_NAV_FLAG: true,

    // css
    // 공통 컴포넌트 높이
    header: 56,
    title: 54,
    tab: 48,
    search: 96,
    bottomBtn: 96,
    bottomNavIos: 82,
    bottomNavAnd: 62,
    moreBtn: 38,
  },
  getters: {
    GET_USER_DATA(state) {
      return state.userData;
    },
    IS_AUTHENTICATED(state) {
      return (
        !!state.authToken && !!state.userKey && !!state.sessionToken
        // && state.userData !== null // ..
      );
    },
    GET_AUTH_TOKEN(state) {
      return state.authToken;
    },
    GET_USER_KEY(state) {
      return state.userKey;
    },
    GET_SESSION_TOKEN(state) {
      return state.sessionToken;
    },
    GET_TOKEN_OBJ(state) {
      return state.tokenObj;
    },
    GET_TAGAG_BTN_FLAG(state) {
      return state.TAGAG_BTN_FLAG;
    },
    GET_LBS_FLAG(state) {
      return state.LBS_FLAG;
    },
    GET_LBS_TEST_DATA(state) {
      return state.LBS_TEST_DATA;
    },
    GET_BOTTOM_NAV_FLAG(state) {
      return state.BOTTOM_NAV_FLAG;
    },

    IS_ANDROID() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.indexOf('android') > -1;
    },
    IS_IOS() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1;
    },
    IS_WEB() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return (
        userAgent.indexOf('iphone') === -1 &&
        userAgent.indexOf('ipad') === -1 &&
        userAgent.indexOf('android') === -1
      );
    },

    /* 스크롤 영역 제외 높이 계산 */
    // 헤더 + 하단 네비게이션
    HEIGHT_BOTTOM_NAV(state, getters) {
      if (getters.IS_IOS) {
        return state.header + state.bottomNavIos;
      } else {
        return state.header + state.bottomNavAnd;
      }
    },
    // 헤더 + 타이틀
    HEIGHT_TITLE(state) {
      return state.header + state.title;
    },
    // 헤더 + 탭
    HEIGHT_TAB(state) {
      return state.header + state.tab;
    },
    // 탭 + 검색어
    HEIGHT_TAB_SEARCH(state) {
      return state.tab + state.search + 5; // margin
    },
    // 헤더 + 타이틀 + 바텀네브
    HEIGHT_TITLE_BOTTOM_NAV(state, getters) {
      return getters.HEIGHT_BOTTOM_NAV + state.title;
    },
    // 헤더 + 타이틀 + 바텀버튼
    HEIGHT_TITLE_BOTTOM_BTN(state, getters) {
      return getters.HEIGHT_TITLE + state.bottomBtn;
    },
    // 헤더 + 바텀버튼
    HEIGHT_BOTTOM_BTN(state) {
      return state.header + state.bottomBtn;
    },
  },
  mutations: {
    setToken(state, data) {
      state.authToken = data.authToken;
      state.userKey = data.userKey;
      state.sessionToken = data.sessionToken;
      saveAuthToCookie(data);
    },
    setTokenObj(state, data) {
      state.tokenObj = {
        authToken: data.authToken,
        userKey: data.userKey,
        sessionToken: data.sessionToken,
        userData: {
          ssnEnterCd: data.ssnEnterCd,
          ssnSabun: data.ssnSabun,
          ssnName: data.ssnName,
          ssnOrgCd: data.ssnOrgCd,
          id: data.id,
          profileImgPath: data.profileImgPath,
          orgChiefYn: data.orgChiefYn,
          authGroup: data.authGroup,
          tenantKey: data.tenantKey,
          lbsUseYn: data.lbsUseYn, // 타각정보(비콘,gps) 사용여부
        },
      };
    },
    setUserData(state, userObj) {
      const userData = {
        ssnEnterCd: userObj.ssnEnterCd,
        ssnSabun: userObj.ssnSabun,
        ssnName: userObj.ssnName,
        ssnOrgCd: userObj.ssnOrgCd,
        id: userObj.id,
        profileImgPath: userObj.profileImgPath,
        orgChiefYn: userObj.orgChiefYn,
        authGroup: userObj.authGroup,
        tenantKey: userObj.tenantKey,
        lbsUseYn: userObj.lbsUseYn, // 타각정보(비콘,gps) 사용여부
      };
      state.userData = userData;
      saveUserToCookie(encodeURIComponent(JSON.stringify(userData)));
    },
    cleanToken(state) {
      state.authToken = '';
      state.userKey = '';
      state.sessionToken = '';
      state.userData = state.initializedUserData;
      deleteCookie('authToken');
      deleteCookie('userKey');
      deleteCookie('sessionToken');
      deleteCookie('userData');
    },
    SET_TAGAG_BTN_FLAG(state, data) {
      state.TAGAG_BTN_FLAG = data;
    },
    SET_LBS_FLAG(state, data) {
      state.LBS_FLAG = data;
    },
    SET_LBS_TEST_DATA(state, data) {
      state.LBS_TEST_DATA = data;
    },
    SET_BOTTOM_NAV_FLAG(state, data) {
      state.BOTTOM_NAV_FLAG = data;
    },
    SET_STATE_TOKEN_FROM_COOKIE(state) {
      state.userData = getUserFromCookie();
      state.authToken = getTokenFromCookie('authToken');
      state.userKey = getTokenFromCookie('userKey');
      state.sessionToken = getTokenFromCookie('sessionToken');
      state.tokenObj = {
        authToken: getTokenFromCookie('authToken'),
        userKey: getTokenFromCookie('userKey'),
        sessionToken: getTokenFromCookie('userKey'),
        userData: getUserFromCookie(),
      };
    },
    // 테스트용 0914
    RESET_STATE_TOKEN(state) {
      state.authToken = '';
      state.userKey = '';
      state.sessionToken = '';
      state.tokenObj = {};
      state.userData = state.initializedUserData;
    },
  },
  actions: {},
  modules: {
    SPINNER: spinnerStore,
    MENU: menuStore,
    ELA: elaStore,
    CODE: codeStore,
    DIALOG: dialogStore,
    WORK_LOG: workLog,
  },
});
